import { AuthCodeExchangeResponse } from '../saml/authCodeExchange'
import { httpPost } from './http'

export const continueCreation = async (response: AuthCodeExchangeResponse): Promise<Response> => {
	return httpPost('/api/trials/continue-creation/', {
		email: response.emailAddress,
		jwt: response.jwt
	})
}
